import React from 'react'
import { Badge } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  CLINIC_FORM_CATEGORY_ICONS,
  CLINIC_FORM_CATEGORY_COLORS,
  CLINIC_FORM_CATEGORY_LABELS
} from '../../config/form-categories'
import BillingProfile from '../../../billing-profile/components/billing-profile'
import { clinicTabsEnums } from '../../config/clinic-tabs-enums'

export const createBillingProfileTab = ({
  token,
  unfilledFields,
  clinicId,
  practiceName,
  handleTabChange,
  disabled,
  billingProfileSaveAction,
  setBillingProfileSaveAction,
  billingProfileForm,
  handleFormSubmit,
  schemesLoading,
  handleValuesChange,
  recordData,
  newRecord,
  schemeOps
}) => {
  return {
    key: clinicTabsEnums.BILLING_PROFILE,
    info: 'This is a test',
    disabled,
    label: (
      <span>
        <FontAwesomeIcon
          icon={CLINIC_FORM_CATEGORY_ICONS.BILLING_PROFILE}
          style={{ marginRight: '8px', color: CLINIC_FORM_CATEGORY_COLORS.BILLING_PROFILE }}
        />
        {CLINIC_FORM_CATEGORY_LABELS.BILLING_PROFILE}
        <Badge count={unfilledFields[6]} style={{ marginLeft: '8px', backgroundColor: token.colorError }} />
      </span>
    ),
    children: (
      <>
        <BillingProfile
          newRecord={newRecord}
          handleTabChange={handleTabChange}
          practiceName={practiceName}
          clinicId={clinicId}
          handleFormSubmit={handleFormSubmit}
          handleValuesChange={handleValuesChange}
          billingProfileForm={billingProfileForm}
          billingProfileSaveAction={billingProfileSaveAction}
          setBillingProfileSaveAction={setBillingProfileSaveAction}
          schemesLoading={schemesLoading}
          schemeOps={schemeOps}
          recordData={recordData}
        />
      </>
    )
  }
}
